import axios from 'axios';
import { API_URL } from '../config';
import type { LoginResponse, User, Announcement } from '../types';

// Extended /me response type
interface MeResponse {
  user: User;
  firmStatus?: string;
  deactivationReason?: string;
  licenseExpiresAt?: string;
  allowedReports?: string[];
  announcements?: Announcement[];
}

const authClient = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

export const authApi = {
  login: async (email: string, password: string): Promise<LoginResponse> => {
    const response = await authClient.post<LoginResponse>('/api/auth/login', {
      email,
      password,
    });
    return response.data;
  },

  getCurrentUser: async (token: string): Promise<User> => {
    const response = await authClient.get<MeResponse>('/api/auth/me', {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data.user;
  },

  getMe: async (token: string): Promise<MeResponse> => {
    const response = await authClient.get<MeResponse>('/api/auth/me', {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  },
};
